export default __webpack_public_path__ + "static/media/WhiteSands.aa0e3434.jpg";